// This file is generated by a script. Do not edit this file directly.
import * as React from 'react';
var getSizeClassName = function getSizeClassName(size) {
  switch (size) {
    case 5:
      return 'cop-h-5 cop-w-5';
    case 10:
    default:
      return 'cop-h-10 cop-w-10';
  }
};

/**
 * Spinner component is used to indicate a loading state of a component or page.
 */
export var Spinner = function Spinner(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React.createElement("svg", {
    className: "".concat(getSizeClassName(size), " cop-animate-rotate"),
    color: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "22 22 44 44"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cop-animate-dash-circle",
    cx: "44",
    cy: "44",
    r: "20.2",
    stroke: "currentColor",
    strokeWidth: "3.6",
    strokeDasharray: "1,200",
    strokeDashoffset: "0"
  }));
};
